import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import WithRender from '@/Pages/Admin/Modules/Invoices/Views/invoices.html';
import {trekService} from '@/Pages/Admin/Modules/ManagePackage/Services/Trekservice';
import {flashService} from '@/Pages/Admin/Modules/Common/Services/FlashMessage/FlashService';
import {common} from '@/Pages/Admin/Modules/Common/Services/Common';
import ValidationError from '@/Pages/Admin/Modules/Common/Controllers/ValidationError';
import Pager from '@/Pages/Admin/Modules/Common/Controllers/Pager';
import Spinner from '@/Pages/Admin/Modules/Common/Controllers/Spinner';



@WithRender
@Component({
  components: {
    Pager,
    Spinner,
    'validation-error': ValidationError
  },
})
export default class Invoices extends Vue {
  protected ui: any = {};
  protected InvoiceLists:any ={};
  protected RequestStartDate: any = '';
  protected RequestEndDate: any = '';
  protected RequestStatus: any = '';
  protected paging: any = {};
  protected errorsInvoice: any = {};

  protected invoiceStatus: any = [
    {id: 'draft', name: 'Draft'},
    {id: 'unpaid', name: 'Unpaid'},
    {id: 'paid', name: 'Paid'},
    {id: 'cancelled', name: 'Cancelled'},
];

constructor() {
        super();
        this.paging.current_page = 1;
        this.paging.last_page = 0;
        this.paging.per_page = 0;
        this.ui.IsLoading = false;

    }
  public mounted() {
    this.callInvoiceList();
}
get permission() {
  return common.permissionCheck;
}

protected async callInvoiceList() {
  this.errorsInvoice = {};
  this.InvoiceLists = {};
  this.ui.IsLoading = true;
  let data = {
      paging: {
          current_page: this.paging.current_page,
          last_page: this.paging.last_page,
          per_page: this.paging.per_page
      },
      search: {
          start_date: this.RequestStartDate,
          end_date: this.RequestEndDate,
          status: this.RequestStatus,
      },
      sorting: {
          sort_by: 'id',
          sort_order: 'desc'
      }
  };

  trekService
      .searchInvoiceByFilter(data)
      .then((res: any) => {
        console.log(res);
          this.InvoiceLists = res.data.data.data;
          // console.log("msg", res.data.data.data)
          // console.log( "msg",res.data.data.data);
          this.paging.last_page = res.data.data.last_page;
          this.paging.per_page = res.data.data.per_page;
      })
      .catch((error: any) => {
          common.sdCatchErr(error, this.errorsInvoice).then(res => {
              this.errorsInvoice = res;
          });
      })
      .finally(() => {
          this.ui.IsLoading = false;
      });
}
public onPaging(CurrentPage: number) {
  this.paging.current_page = CurrentPage;
  this.callInvoiceList();
}

protected toggleFilter() {
  $('.filter-body').slideToggle('medium');
  $('.filter-head').toggleClass('up');
}
public clearAllFilter() {
  this.RequestStartDate = '';
  this.RequestEndDate = '';
  this.RequestStatus = '';
  this.callInvoiceList();
}
public redirectToView(invoice: any, index: any) {
  this.$router.push({
      name: 'user-manage-invoices-view',
      query: {
          uuid: invoice.uuid
      }
  });
}

}
